import React from 'react';
import IconButton from '@/components/buttons/IconButton';

const LookupsButton = ({ onClick, disabled }) => (
  <IconButton
    className="dataset-dictionary-edit-button"
    disabled={disabled}
    onClick={onClick}
    messageId="actions.edit.lookups.title"
    iconOnly
    iconName="list alternate outline"
    iconClassName="primary"
  />
);

export default LookupsButton;
